import { NgModule } from '@angular/core';
import { BaseStorefrontModule } from '@spartacus/storefront';
import { CustomStorefrontModule } from './custom/cms-structure/layout/custom-storefront/custom-storefront.module';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';
import { SpartacusFeaturesModule } from './spartacus-features.module';

@NgModule({
  imports: [BaseStorefrontModule, SpartacusFeaturesModule, SpartacusConfigurationModule, CustomStorefrontModule],
  exports: [CustomStorefrontModule]
})
export class SpartacusModule {}
